import {
  CognitoUserPool,
  CognitoUser,
  AuthenticationDetails
} from "amazon-cognito-identity-js";

// ✅ Session Storage için güvenli fallback
const memoryStore = {};
const Storage = {
  setItem(key, value) {
    try { sessionStorage.setItem(key, value); }
    catch { memoryStore[key] = value; }
  },
  getItem(key) {
    try { return sessionStorage.getItem(key); }
    catch { return memoryStore[key] || null; }
  },
  removeItem(key) {
    try { sessionStorage.removeItem(key); }
    catch { delete memoryStore[key]; }
  },
};

// ✅ Doğru ENV anahtarları
const pool = new CognitoUserPool({
  UserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
  ClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
  Storage
});

// ✅ Login işlemi
export function signIn({ username, password }) {
  const user = new CognitoUser({ Username: username, Pool: pool, Storage });

  const authDetails = new AuthenticationDetails({
    Username: username,
    Password: password
  });

  return new Promise((resolve, reject) => {
    user.authenticateUser(authDetails, {
      onSuccess: (session) => resolve({ type: "SUCCESS", session, user }),
      onFailure: reject,
      newPasswordRequired: (userAttributes) =>
        resolve({ type: "NEW_PASSWORD_REQUIRED", user, userAttributes })
    });
  });
}

// ✅ getCurrentUser
export function getCurrentUser() {
  return pool.getCurrentUser();
}

// ✅ Mevcut session oku
export function getCurrentSession() {
  const user = getCurrentUser();
  if (!user) return Promise.resolve(null);

  return new Promise((resolve) => {
    user.getSession((err, session) => {
      if (err || !session?.isValid()) return resolve(null);
      resolve(session);
    });
  });
}

// ✅ Token asenkron olarak alınır (kritik düzeltme)
export async function getIdToken() {
  const user = getCurrentUser();
  if (!user) throw new Error("No user session");

  return new Promise((resolve, reject) => {
    user.getSession((err, session) => {
      if (err || !session?.isValid()) {
        return reject(new Error("Invalid or expired session"));
      }
      resolve(session.getIdToken().getJwtToken());
    });
  });
}

// ✅ Kullanıcı giriş kontrolü
export async function isAuthed() {
  const session = await getCurrentSession();
  return !!session;
}

// ✅ Çıkış işlemi
export function signOut() {
  const user = getCurrentUser();
  if (user) user.signOut();
  Storage.removeItem("CognitoIdentityServiceProvider");
}
